(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
  if (reduceMotion || coarsePointer) return;

  const selector = '.product-media-container--image';

  const attach = (container) => {
    if (container.dataset.spectralInspectReady === 'true') return;
    const image = container.querySelector('.product-media__image');
    if (!image) return;

    container.dataset.spectralInspectReady = 'true';
    container.style.setProperty('--spectral-inspect-x', '50%');
    container.style.setProperty('--spectral-inspect-y', '50%');
    container.style.setProperty('--spectral-inspect-tilt-x', '0deg');
    container.style.setProperty('--spectral-inspect-tilt-y', '0deg');
      container.style.setProperty('--spectral-inspect-pan-x', '0px');
      container.style.setProperty('--spectral-inspect-pan-y', '0px');

    let rect = null;
    let raf = 0;
    let pointerX = 0.5;
    let pointerY = 0.5;

    const refreshRect = () => {
      rect = container.getBoundingClientRect();
    };

    const render = () => {
      raf = 0;
      if (!rect) refreshRect();
      const offsetX = (pointerX - 0.5) * 2;
      const offsetY = (pointerY - 0.5) * 2;
      container.style.setProperty('--spectral-inspect-x', `${(pointerX * 100).toFixed(2)}%`);
      container.style.setProperty('--spectral-inspect-y', `${(pointerY * 100).toFixed(2)}%`);
      container.style.setProperty('--spectral-inspect-tilt-x', `${(-offsetY * 2.4).toFixed(2)}deg`);
      container.style.setProperty('--spectral-inspect-tilt-y', `${(offsetX * 3.8).toFixed(2)}deg`);
      container.style.setProperty('--spectral-inspect-pan-x', `${(-offsetX * 18).toFixed(1)}px`);
      container.style.setProperty('--spectral-inspect-pan-y', `${(-offsetY * 14).toFixed(1)}px`);
    };

    const reset = () => {
      pointerX = 0.5;
      pointerY = 0.5;
      rect = null;
      if (!raf) raf = requestAnimationFrame(render);
      container.classList.remove('spectral-inspecting');
    };

    const handlePointerEnter = (event) => {
      if (event.pointerType !== 'mouse') return;
      refreshRect();
      container.classList.add('spectral-inspecting');
    };

    const handlePointerMove = (event) => {
      if (event.pointerType !== 'mouse') return;
      if (!rect) refreshRect();
      pointerX = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
      pointerY = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
      if (!raf) raf = requestAnimationFrame(render);
    };

    container.addEventListener('pointerenter', handlePointerEnter);
    container.addEventListener('pointermove', handlePointerMove);
    container.addEventListener('pointerleave', reset);
    window.addEventListener('resize', () => { rect = null; }, { passive: true });
  };

  const scan = (root = document) => root.querySelectorAll(selector).forEach(attach);

  scan();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(selector)) attach(node);
        scan(node);
      });
    }
  });

  const observeRoot = document.querySelector('#MainContent') || document.body;
  observer.observe(observeRoot, { childList: true, subtree: true });
})();
